.Prompt b {
  font-size: 1.4em;
  color: #d54b33;
}
.ProgressReportsHUD {
  z-index: 100;
  top: 0em;
  right: 0em;
  bottom: 0em;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.ProgressReportsHUD .ProgressReport {
  border-top-right-radius: 0em;
  border-bottom-right-radius: 0em;
}
.ProgressReport {
  gap: 0.2em;
  padding: 0.2em;
  padding-top: 0em;
  position: relative;
  width: 3.5em;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  border-radius: 0.05em;
  box-shadow: 0.1em 0.1em 0.1em rgba(0, 0, 0, 0.5);
  background-image: url("./textures/notebook-dark.png");
  background-blend-mode: multiply;
}
.ProgressReport:not(:last-child) {
  margin-bottom: 0.33em;
}
.ProgressReport[element=fire] {
  background-color: #bf4b3f;
}
.ProgressReport[element=water] {
  background-color: #3dc4c1;
}
.ProgressReport[element=earth] {
  background-color: #47be5d;
}
.ProgressReport .Thumbnail {
  width: 1em;
  height: 1em;
  font-size: 0.66em;
  position: relative;
}
.ProgressReport .Progress {
  width: 2em;
}
.ProgressReport .Progress .Summary {
  font-size: 0.3em;
  font-family: var(--header-font);
  text-stroke: 0.25em #111111;
  -ms-text-stroke: 0.25em #111111;
  -moz-text-stroke: 0.25em #111111;
  -webkit-text-stroke: 0.25em #111111;
  paint-order: stroke fill;
}
.ProgressReport .Progress .LevelingDescription {
  font-size: 0.2em;
  margin: 0.2em 0em;
  color: #111111;
}
.ProgressReport .Progress .Experience {
  position: relative;
}
.ProgressReport .Progress .Experience .UnitExperienceBar {
  height: 0.2em;
  border-radius: 0.05em;
}
.ProgressReport .Progress .Experience .UnitExperienceBar .Fill {
  background-color: #111111;
}
.ProgressReport .Progress .Experience .Label {
  top: -0.1em;
  left: 0em;
  right: 0em;
  z-index: 10;
  font-size: 0.2em;
  text-align: center;
  position: absolute;
  text-stroke: 0.25em #111111;
  -ms-text-stroke: 0.25em #111111;
  -moz-text-stroke: 0.25em #111111;
  -webkit-text-stroke: 0.25em #111111;
  paint-order: stroke fill;
}
.ProgressReport .Message {
  position: absolute;
  top: 0em;
  bottom: 0em;
  right: 3.75em;
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.ProgressReport .Message .Text {
  font-size: 0.2em;
  line-height: 1em;
  padding: 0.1em 0.6em;
  border-radius: 0.1em;
  background-color: rgba(0, 0, 0, 0.5);
}
.SchoolLevelupModal {
  top: 0em;
  left: 0em;
  right: 0em;
  bottom: 0em;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
}
.SchoolLevelupModal .Portrait {
  height: 6em;
  pointer-events: none;
}
.SchoolLevelupModal .Details {
  width: 6em;
  height: 100%;
  margin: 0em 0.6em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.SchoolLevelupModal .Details .HeaderSection {
  text-align: center;
}
.SchoolLevelupModal .Details .HeaderSection .Thumbnail {
  height: 1em;
  position: relative;
}
.SchoolLevelupModal .Details .HeaderSection .Declaration {
  font-size: 0.6em;
  line-height: 1em;
  margin-bottom: 0.33em;
  text-stroke: 0.25em #111111;
  -ms-text-stroke: 0.25em #111111;
  -moz-text-stroke: 0.25em #111111;
  -webkit-text-stroke: 0.25em #111111;
  paint-order: stroke fill;
  text-align: center;
  font-family: var(--header-font);
}
.SchoolLevelupModal .Details .HeaderSection .Description {
  font-size: 0.3em;
  line-height: 1em;
  margin-bottom: 0.33em;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 0.5em;
  padding: 0.2em;
  display: flex;
  align-items: center;
  justify-content: center;
}
.SchoolLevelupModal .Details .HeaderSection .Description .Arrow {
  font-size: 0.5em;
  margin: 0em 0.5em;
}
.SchoolLevelupModal .Details .HeaderSection .Description .Arrow::after {
  content: "➤";
}
.SchoolLevelupModal .Details .PerksSection {
  width: 100%;
  display: grid;
  gap: 0.2em;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  cursor: pointer;
}
.SchoolLevelupModal .Details .PerksSection[element=fire] .Perk[hasUnlocked],
.SchoolLevelupModal .Details .PerksSection[element=fire] .Perk:hover {
  background-color: #bf4b3f;
  transition-duration: 0.1s;
  transform: none;
}
.SchoolLevelupModal .Details .PerksSection[element=water] .Perk[hasUnlocked],
.SchoolLevelupModal .Details .PerksSection[element=water] .Perk:hover {
  background-color: #3dc4c1;
  transition-duration: 0.1s;
  transform: none;
}
.SchoolLevelupModal .Details .PerksSection[element=earth] .Perk[hasUnlocked],
.SchoolLevelupModal .Details .PerksSection[element=earth] .Perk:hover {
  background-color: #47be5d;
  transition-duration: 0.1s;
  transform: none;
}
.SchoolLevelupModal .Details .PerksSection .Perk {
  padding: 0.25em;
  font-size: 0.5em;
  text-align: center;
  border-radius: 0.1em;
  box-shadow: 0.1em 0.1em 0.1em rgba(0, 0, 0, 0.5);
  transition-duration: 0.2s;
  transition-property: background-color;
  color: #111111;
  background-image: url("./textures/notebook-dark.png");
  background-blend-mode: multiply;
  background-size: cover;
  background-color: #f0ead6;
  transform-origin: center;
  transform: rotate(-2deg);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.SchoolLevelupModal .Details .PerksSection .Perk:nth-child(2n) {
  transform: rotate(2deg);
}
.SchoolLevelupModal .Details .PerksSection .Perk .Title {
  font-size: 0.6em;
  font-weight: bold;
}
.SchoolLevelupModal .Details .PerksSection .Perk .Description {
  font-size: 0.4em;
}
.SchoolChapterSummary {
  top: 0em;
  left: 0em;
  right: 0em;
  bottom: 0em;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
}
.SchoolChapterSummary .Sidebar {
  width: 4.5em;
  height: 100%;
  padding: 0.5em;
  top: 0em;
  right: 0em;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.SchoolChapterSummary .Sidebar .GraphSection {
  width: 3.5em;
  height: 3em;
  margin-bottom: 0.5em;
  border-radius: 0.3em;
  background-color: #2D2D2A;
  box-shadow: 0.1em 0.1em 0.1em rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.SchoolChapterSummary .Sidebar .GraphSection .Text {
  font-size: 0.2em;
}
.SchoolChapterSummary .Declaration {
  font-size: 0.6em;
  line-height: 1em;
  margin-bottom: 0.33em;
  text-stroke: 0.25em #111111;
  -ms-text-stroke: 0.25em #111111;
  -moz-text-stroke: 0.25em #111111;
  -webkit-text-stroke: 0.25em #111111;
  paint-order: stroke fill;
  text-align: center;
  font-family: var(--header-font);
}
